// Session ID for temp uploads — unique per page load, shared across both email editor contexts
const SESSION_ID = `${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
const TEMP_SESSION_KEY = 'designAssetsTempSession';

function getTempSession() {
    try {
        const raw = window.sessionStorage.getItem(TEMP_SESSION_KEY);
        if (raw) return JSON.parse(raw);
    } catch (_) { /* ignore */ }
    return { sessionId: SESSION_ID, files: [] };
}

export const constructTemporaryUrl = (file) => {
    const timestamp = Date.now();
    const randomId = Math.random().toString(36).substring(2, 10);
    const fileExtension = file instanceof File ? (file.name.split('.').pop() || 'png') : 'png';
    const fileName = `${timestamp}-${randomId}.${fileExtension}`;
    const session = getTempSession();
    const tempPath = `temp/${session.sessionId}/${fileName}`;

    return tempPath;
}